import { PAGE_ROUTES } from '@lyrahealth-inc/shared-app-logic'

import { getLocationObj } from './page-navigation-actions'
import * as MixpanelActions from '../../../../data/mixpanel'
import { appRouter_DO_NOT_USE as appRouter } from '../../../routing/legacyRouterShim'

/**
 * @deprecated Please do not add any more new usages of this. Components should generally use
 * useNavigate() or <Navigate /> to navigate with react-router.
 */
export function changeRoute(route: string, base = '/secure/onboard/') {
  return function (dispatch: $TSFixMe) {
    appRouter.navigate({ pathname: base + route })
    dispatch(setMixpanelOnLoadPage())
  }
}

export function setMixpanelOnLoadPage() {
  return function (dispatch: $TSFixMe, getState: $TSFixMe) {
    const state = getState()
    const locationObj = getLocationObj(state)
    switch (locationObj.route) {
      case PAGE_ROUTES.ABOUT:
      case PAGE_ROUTES.ABOUT_CHILD:
        break
      case PAGE_ROUTES.MATCHES:
        if (locationObj.subroute === '') {
          dispatch(routeMixpanelAction({ page: MINI_MATCHER_MAP.location }))
        } else {
          dispatch(routeMixpanelAction({ page: MINI_MATCHER_MAP[locationObj.subroute] }))
        }
        break
      case PAGE_ROUTES.VIDEO_THERAPY:
        dispatch(
          routeMixpanelAction({
            page: ONBOARD_PAGES[locationObj.route],
            action: MixpanelActions.MIXPANEL_ACTION.GO_TO_DOD,
          }),
        )
        break
      case (PAGE_ROUTES as $TSFixMe).RESULTS:
        dispatch(
          routeMixpanelAction({
            page: ONBOARD_PAGES[locationObj.route],
            action: MixpanelActions.MIXPANEL_ACTION.PROVIDERS_MATCHED,
          }),
        )
        break
      case PAGE_ROUTES.UNSUPPORTED_OPTION:
        dispatch(
          routeMixpanelAction({
            page: ONBOARD_PAGES[locationObj.route],
            action: MixpanelActions.MIXPANEL_ACTION.UNSUPPORTED_OPTION,
          }),
        )
        break
      case PAGE_ROUTES.COACHING.DEFAULT:
      case PAGE_ROUTES.MATCH_LOCATION:
      case PAGE_ROUTES.COACHING_SESSION_MODALITY_SELECTION:
        break // Defer Mixpanel page loads to per-component handling
      default:
        if (Object.keys(ONBOARD_PAGES).includes(locationObj.route)) {
          dispatch(routeMixpanelAction({ page: ONBOARD_PAGES[locationObj.route] }))
        }
    }
  }
}

export function routeMixpanelAction({ page, action }: $TSFixMe) {
  return function (dispatch: $TSFixMe) {
    dispatch(MixpanelActions.handleOnboardPageLoad(page, action))
  }
}

export const CMS_MICROSITE_ROUTES = [PAGE_ROUTES.COMPLEX_CARE, PAGE_ROUTES.ELECTION, PAGE_ROUTES.SOCIAL_CARE]

export const HPI_ROUTES = [
  PAGE_ROUTES.HPI_COVERAGE_CHECK.HEALTH_PLAN_FORM,
  PAGE_ROUTES.HPI_COVERAGE_CHECK.PAYMENT_INFO_FORM,
  PAGE_ROUTES.HPI_COVERAGE_CHECK.INFRACTION_PAYMENT_INFO_FORM,
  PAGE_ROUTES.HPI_COVERAGE_CHECK.HEALTH_PLAN_PENDING,
  PAGE_ROUTES.HPI_COVERAGE_CHECK.HEALTH_PLAN_INELIGIBLE,
  PAGE_ROUTES.HPI_COVERAGE_CHECK.APPOINTMENT_HPI_OVERVIEW,
  PAGE_ROUTES.HPI_COVERAGE_CHECK.APPOINTMENT_PAYMENT_INFO_FORM,
]

export const PROFILE_EDIT_PAGES = [
  PAGE_ROUTES.PROFILE.CHANGE_EMAIL,
  PAGE_ROUTES.PROFILE.ENROLL_MFA,
  PAGE_ROUTES.PROFILE.VERIFY_MFA,
  PAGE_ROUTES.PROFILE.UPDATE_LOCATION,
  PAGE_ROUTES.PROFILE.UPDATE_PERSONAL_INFORMATION,
  PAGE_ROUTES.PROFILE.UPDATE_CHILD_INFORMATION,
  PAGE_ROUTES.PROFILE.UPDATE_NOTIFICATION_SETTINGS,
  PAGE_ROUTES.PROFILE.UPDATE_LYRA_UPDATES_SETTINGS,
  PAGE_ROUTES.PROFILE.UPDATE_LANGUAGE,
  PAGE_ROUTES.PROFILE.UPDATE_PHONE_NUMBER,
  PAGE_ROUTES.PROFILE.UPDATE_THEME,
  PAGE_ROUTES.PROFILE.UPDATE_PERSONAL_INFORMATION_QUESTIONNAIRE,
  PAGE_ROUTES.PROFILE.UPDATE_CUSTOM_NOTIFICATIONS,
  PAGE_ROUTES.PROFILE.ADD_FAMILY_MEMBER,
  PAGE_ROUTES.PROFILE.DEPENDENT_CONFIRMATION,
]

export const PROFILE_CONFIRMATION_PAGES = [PAGE_ROUTES.PROFILE.SELF_MANAGED_CONFIRMATION]

export const ONE_TRUST_COOKIE_BANNER_ROUTES = [PAGE_ROUTES.LOGIN, PAGE_ROUTES.MICROSITE]

export const BLOCKED_ROUTES_FOR_DISABLED_CLIENTS = [
  PAGE_ROUTES.ONBOARD_BASE,
  PAGE_ROUTES.PROFILE.ADD_FAMILY_MEMBER,
  PAGE_ROUTES.ESSENTIALS_EVENTS,
  PAGE_ROUTES.FAVORITED_PROVIDERS,
]

/* -------------------------------------
 |THIS MAPS to mixpanel pages
 --------------------------------------- */
export const ONBOARD_PAGES = {
  'about-child': 'Child Info',
  'about-other-adult': 'Other Adult Info',
  results: 'Provider Results',
  asd: 'CA Help',
  unsupported: 'Unsupported Medication Recommendation',
  devConcern: 'CA Help',
  'video-therapy': 'Video Therapy Intro',
  'match-location': 'Location',
  't1-provider': 'Onsite Option Provider',
}
export const TRIAGE_ELEMENT_MAP = {
  NEEDS: 'Needs',
  TRIAGEWORDS: 'Wordgrid',
  SEVERITY: 'Severity',
  TREATMENTRECS: 'Treatment Recommendations',
  TREATMENTTOPICS: 'Therapy Styles',
  TREATMENTPREFS: 'Treatment Preferences',
  MEDSOPTIONS: 'Meds Program Options',
}

export const MINI_MATCHER_MAP = {
  location: 'Location',
  insurance: 'Insurance',
}
